import { IGroupsTree } from '../../../store/modules/facility/i-facility';

const findGroupInTheTree = (root:IGroupsTree[], groupId:number) : IGroupsTree | null => {
  const stack : IGroupsTree[] = [...root];
  let node;
  let i : number;

  while (stack.length > 0) {
    node = stack.pop();
    if (node?.id === groupId) {
      // Found it!
      return node;
    } if (node?.children && node.children.length) {
      for (i = 0; i < node.children.length; i += 1) {
        if (node.children[i]) {
          stack.push(node?.children[i]);
        }
      }
    }
  }

  // Didn't find it. Return null.
  return null;
};

export default findGroupInTheTree;
